import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  MarkWorkOrderStarted,
  MarkWorkOrderStartedVariables,
} from '../../athena/types/MarkWorkOrderStarted';

export const MARK_WORK_ORDER_STARTED = gql`
  mutation MarkWorkOrderStarted($workOrderID: String) {
    homework {
      commenceWorkOrder(input: { workOrderId: $workOrderID }) {
        id
        state
      }
    }
  }
`;

const useMarkWorkOrderStarted = () => {
  return useMutation<MarkWorkOrderStarted, MarkWorkOrderStartedVariables>(MARK_WORK_ORDER_STARTED);
};

export default useMarkWorkOrderStarted;
